fx.ns("models", class ProductBook extends  models.Creation {

	constructor(data)
	{
		super(data);
        this.product_type_id = models.ProductType.BOOK;
	}

    // Declared in bottom, trick for old browsers
    // static SQUARE = "square";
    // static PORTRAIT = "portrait";
    // static LANDSCAPE = "landscape";

    // static SPIRAL = "spiral";
    // static BIND = "bind";
    // static SOFT = "standard";
    // static HARD = "hard";
    // static LAYFLAT = "layflat";

    get pages()
    {
        return this.elements;
    }

    /******************** Getters / Setters *****************/

	get isSpiral()
	{
		return this.cover_option == models.ProductBook.SPIRAL
	}

	get isBind()
	{
		return this.cover_option == models.ProductBook.BIND
	}

	get isSoft()
	{
		return this.cover_option == models.ProductBook.SOFT
	}

	get isHard()
	{
		return this.cover_option == models.ProductBook.HARD
	}

	get isLayFlat()
	{
		return this.cover_option == models.ProductBook.LAYFLAT
	}

	get is3d()
	{
		return this.convert_picture_type == "3d";
	}
	
	get shapes()
	{
		return [models.ProductBook.SQUARE, models.ProductBook.PORTRAIT, models.ProductBook.LANDSCAPE];
	}

	get isCreatedFromFile()
	{
		return this.createdfrom == "pdf";
	}

	get cover()
	{
		if (!this.elements) return null;
		return this.elements.find({typeid : 6});
	}

	get hasSlice()
	{
		return this.isHard || this.isLayFlat || (this.isSoft && this.numberPages >= 40);
	}

	get sliceText()
	{
		if (this.hasSlice)
			return fx.text("Cliquez pour personnaliser la tranche");
		else
		if (this.isSoft)
			return fx.text("L'ajout de texte sur la tranche n'est possible que si votre album contient au moins 40 pages");
		else
			return fx.text("L'ajout de texte sur la tranche n'est possible que : <ul><li>Sur une couverture rigide</li><li>Sur une couverture souple avec au moins 40 pages</li></ul>");
	}

	get innerPages()
	{
		if (!this.elements) return [];

		return this.elements.filter( function(page) { return page.typeid == 1; });
	}

	get sliceWidth()
	{
		switch(this.cover_option)
		{
			case models.ProductBook.SOFT:  return 10;
			case models.ProductBook.HARD:  return 15;
			case models.ProductBook.LAYFLAT:  return 15;
			case models.ProductBook.SPIRAL : return 0;
			case models.ProductBook.BIND : return 0;
		}	
	}

	get coverWidth()
	{
		let width;

		switch(this.shape_option)
		{
			case models.ProductBook.SQUARE : width = 210; break;
			case models.ProductBook.LANDSCAPE : width = 300; break;
			case models.ProductBook.PORTRAIT : width = 210; break;
		}

		return (width * 2) + this.sliceWidth;
	}

	get coverHeight()
	{
		//return this.pageHeight;

		switch(this.shape_option)
		{
			case models.ProductBook.SQUARE : return 215;
			case models.ProductBook.LANDSCAPE : return 215; 
			case models.ProductBook.PORTRAIT : return 300; 
		}
	}

	get pageWidth()
	{
		switch(this.shape_option)
		{
			case models.ProductBook.SQUARE : return 210;
			case models.ProductBook.LANDSCAPE : return 300;
			case models.ProductBook.PORTRAIT : return 210;
		}
	}

	get pageHeight()
	{
		switch(this.shape_option)
		{
			case models.ProductBook.SQUARE : return 215;
			case models.ProductBook.LANDSCAPE : return 215;
			case models.ProductBook.PORTRAIT : return 300;
		}
	}

	get formats()
	{
		return this._formats;
	}

	set formats(val)
	{
		this._formats = val;
	}

	get format()
	{
		if (!this._formats || !this.formatid)
			return null;

		for (let i = 0; i < this._formats.length; i++)
			if (this._formats[i].id == this.formatid)
				return this._formats[i];

		return null;
	}


	get canRemove(){
		return this.minPages < this.numberPages;
	}

	get pagesCanRemove()
	{
		return this.numberPages - this.minPages;
	}

	get canAdd(){
		return this.maxPages > this.numberPages;
	}

    get slicePossible()
	{
		return this.cover_option == models.ProductBook.HARD || 
				this.cover_option == models.ProductBook.LAYFLAT ||
				(this.cover_option == models.ProductBook.SOFT && this.numberPages >= 40);
	}

    get numberPages()
	{
		return (this.innerPages.length > 0) ? ( (this.innerPages.length-1) * 2) : this.numpages;
	}

	get minPages()
	{
		return this.coverChoice ? this.coverChoice.min_pages : 0;
	}

	get maxPages()
	{
		return this.coverChoice ? this.coverChoice.max_pages : 0;
		
	}

	get numberSpirals()
	{
		switch(this.shape_option)
		{
			case models.ProductBook.SQUARE : return 23;
			case models.ProductBook.LANDSCAPE : return 16;
			case models.ProductBook.PORTRAIT : 
			default:
			return 23;
		}
	}


	get totalPrice()
    {
		return this.calculatePrice();
    }

	/*
	* if option not given : use book option
	* if numpages not given or set to true : use book num pages
	*/
	calculatePrice(option, numpages, raw)
	{
		if (option === undefined)
			option = this.coverChoice;

		if (numpages === false) // default
		{
			numpages = option.min_pages;
		}
		else
		{
			if (numpages === true || numpages == undefined)
				numpages = this.numberPages;
		}

		var price = 0;

		if (option)
		{
			price =  option.price_base;
			price += (numpages > option.nb_page_base ? (option.extra_four_pages/4) * (numpages - option.nb_page_base) : 0);
			price = price * fx.get("lang").tax; // TAX : TODO get tax rate from database
		}

        return raw ? price : (price.toFixed(2) + " €") ;
	}

	get extraPages()
	{
		return this.numberPages - this.coverChoice.nb_page_base;
	}

	get pagesPrice()
	{
		return (this.numberPages > this.coverChoice.nb_page_base ? (this.coverChoice.extra_four_pages/4) * (this.numberPages - this.coverChoice.nb_page_base) : 0) * fx.get("lang").tax;
	}

	getExtraPriceLayFlat(formatid)
	{
		if (!formatid)
		formatid = this.formatid;

		let hard = this.coverChoices.find({formatid : formatid, option_id : this.coverChoices.getOptionId(models.ProductBook.HARD)});
		let layflat = this.coverChoices.find({formatid : formatid, option_id : this.coverChoices.getOptionId(models.ProductBook.LAYFLAT)});

		return (this.calculatePrice(layflat, true, true) - this.calculatePrice(hard, true, true)).toFixed(2);
	}



	get coverName()
	{
		let cover = this.covers.find({code : this.cover_option});
		return cover ? cover.label : "";
	}

	get coverType()
	{
		switch(this.cover_option)
		{
			case models.ProductBook.BIND : return fx.text("Couverture Agrafée");
			case models.ProductBook.SPIRAL : return fx.text("Couverture Spirale");
			case models.ProductBook.SOFT : return fx.text("Couverture Souple");
			case models.ProductBook.HARD : return fx.text("Couverture Rigide");
			case models.ProductBook.LAYFLAT : return fx.text("Ouverture à plat");
		}
	}

	get coverChoices()
	{
		if (!this._coverChoices)
		{
			this._coverChoices = new repositories.CoversRepository()
			this._coverChoices.parentModel = this;
		}
				

		return this._coverChoices;
	}



	availableCoverChoicesForShapeSize(shape, size)
	{
		return this.coverChoices.filter( (option)=>  option.active && option.cover && option.format && option.format.size == size && option.format.style == shape );
	}

	availableCoverChoices(formatid)
	{
		if (!formatid)
			formatid = this.formatid;

		return this.coverChoices.filter( (option) => option.active && option.cover && option.formatid == formatid );
	}

	get coverChoice()
	{
		let choice;
		for(let i = 0; i < this.coverChoices.length; i++)
		{
			choice = this.coverChoices.getItemAt( i );

			if (choice.formatid == this.formatid && choice.option_id == this.optionid)
				return choice;
		}
			
		return null;
	}

    getCover(cover)
    {
        return this.coverChoices.getCover(cover)
    }

	getOptionAsset(option)
	{
		let coverOption = option ? option.cover.editor_code : this.cover_option;
		
		switch(coverOption)
		{
			case models.ProductBook.BIND : 
				return fx.assets.coverBind;
			case models.ProductBook.SPIRAL : 
				return fx.assets.coverSpiral;
			case models.ProductBook.SOFT : 
				return fx.assets.coverSoft;
			case models.ProductBook.HARD : 
				return fx.assets.coverHard;
			case models.ProductBook.LAYFLAT : 
				return fx.assets.coverHardLayFlat;
		}
	}

	// the product the album was created from is a stapled notebook : the only case where the
	// stapled cover is worth proposing
	get isStapledProduct()
	{
		return !!this.product && this.product.option_id == this.coverChoices.getOptionId(models.ProductBook.BIND);
	}

	// Price of the album printed in the given format : with its current cover when that format
	// offers it, otherwise with the cheapest cover fitting its page count (what a format change
	// falls back to). null when no cover of that format can take the album.
	formatPrice(formatid)
	{
		let option = this.coverChoices.find({formatid : formatid, option_id : this.optionid});

		if (!option || !option.active)
		{
			option = null;

			let options = this.availableCoverChoices(formatid);
			for (let i = 0; i < options.length; i++)
			{
				let candidate = options.getItemAt(i);

				if (this.numberPages < candidate.min_pages || this.numberPages > candidate.max_pages)
					continue;

				if (!option || this.calculatePrice(candidate, true, true) < this.calculatePrice(option, true, true))
					option = candidate;
			}
		}

		return option ? this.calculatePrice(option, true, true) : null;
	}

	// Covers the album can be printed with : the active ones of its format whose page range
	// takes it - the stapled one only for a stapled notebook product, unless it is the album's
	// current cover. Cheapest first.
	possibleCovers()
	{
		let options = this.availableCoverChoices();
		let list = [];

		for (let i = 0; i < options.length; i++)
		{
			let option = options.getItemAt(i);

			if (this.numberPages < option.min_pages || this.numberPages > option.max_pages)
				continue;

			if (option.cover.editor_code == models.ProductBook.BIND && !this.isStapledProduct && option.option_id != this.optionid)
				continue;

			list.push(option);
		}

		list.sort((a, b) => this.calculatePrice(a, true, true) - this.calculatePrice(b, true, true));

		return list;
	}

	// true when one of the given covers (editor codes) can take the album
	hasPossibleCover()
	{
		let covers = this.possibleCovers();

		for (let i = 0; i < arguments.length; i++)
			if (covers.some((option) => option.cover.editor_code == arguments[i]))
				return true;

		return false;
	}

	// Order flow, cover never picked : the possible covers, four at most
	coverChoicesToPick()
	{
		return this.possibleCovers().slice(0, 4);
	}

	// Order flow, cover already picked : the current cover and the pricier possible ones, four
	// at most. Empty when the current cover is the most expensive one.
	coverUpgradeChoices()
	{
		let covers = this.possibleCovers();
		let index = covers.findIndex((option) => option.option_id == this.optionid);

		if (index < 0 || index == covers.length - 1)
			return [];

		return covers.slice(index, index + 4);
	}

	get covers()
	{
		if (!this._covers)
			this._covers =  [	{label : fx.text("Couverture Agrafée"), code : models.ProductBook.BIND}, 
								{label : fx.text("Couverture Spirale"), code : models.ProductBook.SPIRAL}, 
								{label : fx.text("Couverture Souple"), code : models.ProductBook.SOFT}, 
								{label : fx.text("Couverture Rigide"), code : models.ProductBook.HARD}, 
								{label : fx.text("Ouverture à plat"), code : models.ProductBook.LAYFLAT} ];

		return this._covers;
	}

    get hasContent()
	{
		let hasContent = false;
		for (let i = 0; i < this.elements.length; i++)
		{
			let element = this.elements.getItemAt(i);
			for (let j = 0; j < element.components.length; j++)
			{
				let component = element.components.getItemAt(j);

				if (component.component_type == "photo" && component.content)
				{
					hasContent = true;
					break;
				}
			}
		}

		return hasContent;
	}



    // updates books format at creation and set right number of pages
    setFormat(bookformat)
    {
        // we get the option with fewer pages
        let options = this.availableCoverChoicesForShapeSize(this.shape_option, bookformat.size)
                          .sort((a, b) => a.nb_page_base - b.nb_page_base);

        this.formatid = bookformat.id;
        this.optionid = options[0].option_id;

        while(bookformat.pages_base < this.numberPages)
            this.innerPages.last().delete();
    }

    movePage(page, referencePage, side)
    {
        this.moveElement(page, referencePage, side);
    }

    addPage(referenceElement, side, notBackcover, noLayouts, layouts)
    {
        if (referenceElement && referenceElement.hasbackcover && notBackcover)
        {
            if (referenceElement.isLastPage)
                referenceElement = this.innerPages[this.innerPages.length - 2];
        }

        // data.layoutid == 0 means it's a single page, used for example in LayoutEditor, trick in order to not create a new column in "page" table (huge table which requires some times for each new column)
        let newPage = new models.ProductBookPage({creation_id : this.id, layoutid : referenceElement === true ? 0 : -1});
        // let's apply some layout
            
        let index = referenceElement ? ((referenceElement && referenceElement !== true) ? this.elements.indexOf(referenceElement) : 0) : this.elements.length;

        if (side == "right")
            index++;
            
        this.elements.addItemAt( index, newPage );

        newPage.addBackgrounds();

        this.updateNumbering();

        // adding default layout
        if (noLayouts)
        {
            let layout = layouts.getDefaultLayout();	

            if (!layout) return newPage;
            
            if(!newPage.isFirstPage)
                newPage.applyLayout( layout, this.pageWidth, this.pageHeight, 0, "left");

            if (!newPage.isLastPage || newPage.isFirstPage)
                newPage.applyLayout( layout, this.pageWidth, this.pageHeight, 0, "right");

            if (newPage.isLastPage || newPage.isFirstPage)
            {
                let previousPage = this.elements.getItemAt( this.elements.indexOf( newPage) + (newPage.isLastPage ? - 1 : 1) );

                previousPage.applyLayout( layout, this.pageWidth, this.pageHeight, 0, newPage.isLastPage ? "right" : "left");
            }

            //return newPage;
        }
        else
        {
            let layout = layouts.getLayoutForPage(this.numberPages, newPage.isFirstPage ? "right" : (newPage.isLastPage ? "left" : ""), this.themeid);

            if(!layout) return newPage;
            
            newPage.applyLayout( layout, this.pageWidth, this.pageHeight, 0, newPage.isFirstPage ? "right" : (newPage.isLastPage ? "left" : ""));

            if (newPage.isLastPage || newPage.isFirstPage) // we add page at the end, so let's apply layout on right side on last previous page
            {
                let previousPage = this.elements.getItemAt( this.elements.indexOf( newPage) + (newPage.isLastPage ? - 1 : 1) );

                layout = layouts.getLayoutForPage(this.numberPages - 2, newPage.isLastPage ? "right" : "left", this.themeid);

                previousPage.applyLayout( layout, this.pageWidth, this.pageHeight, 0, newPage.isLastPage ? "right" : "left");
            }

        }
        return newPage;
    }


    onUpdated(action)
	{
        super.onUpdated(action);

		// init pagination values when adding pagination
		/*if(action.impacts("pagenumbers"))
        {
			this.pagenumbers_bgcolor = "rgba(255, 255, 255, 0.5)";
			this.pagenumbers_textcolor = "#000000";
			this.pagenumbers_fontsize = 8;
			this.pagenumbers_fontfamily = "Open Sans";
		}
        else*/
        if (action.impacts("formatid"))
        {
            if (this.coverChoice == null)
            {
                // choisir la premiere couverture disponible
                
                this.coverChoices.sort(function(a, b) { return a.price_base - b.price_base;});
                let coverObj;
                for(let i = 0; i < this.coverChoices.length; i++)
                {
                    let coverOption = this.coverChoices.getItemAt(i);
                    if (coverOption.min_pages <= this.numberPages && coverOption.max_pages >= this.numberPages)
                    {
                        coverObj = coverOption;
                        break;
                    }
                }

                if (coverObj)
                {
                    this.updateCover(coverObj);
                    // envoyer un event pour prévenir
                    this.event("cover-force-updated");
                }
                else
                {
                    //console.log("Couverture introuvable");
                    fx.log.error("Couverture introuvable");
                }
            }
        }
    }
    
    updateCover(coverChoice)
	{
		if (this.numberPages > coverChoice.max_pages || this.numberPages < coverChoice.min_pages)
		{
			this.event("cover-update-impossible", coverChoice);
			return;
		}
		
        let previousSliceWidth = this.sliceWidth;
        
        this.update({cover_option : coverChoice.cover.editor_code, optionid : coverChoice.option_id});
        
        this.price_min_base = coverChoice.price_base;
        this.nb_page_base_min = coverChoice.nb_page_base;
        this.extra_four_pages_min = coverChoice.extra_four_pages;
        
        // update cover element positions
        let offset = this.sliceWidth - previousSliceWidth;

        for (let i = 0; i < this.cover.components.length; i++)
        {
            let component = this.cover.components.getItemAt(i);

            if (component.isBackground)
                continue;

            let rect = fx.graphics.getBoundingRect(component, component.rotation);

            if (Math.round(rect.x) >= this.pageWidth)
            {
                component.x += offset;
            }
        }

        for (let i = 0; i < this.elements.length; i++)
            this.elements.getItemAt(i).event("cover-updated");
	}

	

    // apply layout to all inner page
	applyLayout( layout )
	{
		let pages = this.innerPages;
		for(let i = 0; i < pages.length; i++)
			pages.getItemAt(i).applyLayout( layout,  pages.getItemAt(i).isFirstPage ? this.pageWidth : (2*this.pageWidth), this.pageHeight, 0);
	}

    // apply background to all pages
	applyBackgroundAll( background )
    {
        for(let i = 0; i < this.pages.length; i++)
        {
            let page = this.pages.getItemAt(i);
            if (!page.isCover)
			    page.applyBackground( background );
        }
    }

    // apply background color to all pages
	applyBackgroundColorAll(backgroundColor)
    {
        for(let i = 0; i < this.pages.length; i++)
        {
            let page = this.pages.getItemAt(i);
            if (!page.isCover)
                page.updateBackgroundColor( backgroundColor, "both", true, true );
        }
			
    }


    // Numbering for book is different, it has to take into account cover, and backcovers
    updateNumbering(history)
	{
		for (let i = 0; i < this.elements.length; i++)
		{
			let page = this.elements.getItemAt(i);

			if (page.isCover)
				continue;
			
			let hasbackcover = ( ( i == 1) || (i == (this.elements.length-1) ) ) ? 1 : 0;

			let updates = {};
		
			if (page.number != i)
				updates.number = i;

            if (this.product_type_id == models.ProductType.BOOK && page.hasbackcover != hasbackcover)
				updates.hasbackcover = hasbackcover;

			if (Object.keys(updates).length > 0)
				page.update( updates, {history : !!history} );
				
		}

		this.event("numbering-changed")
	}
});

fx.ns("models.ProductBook").SQUARE = "square";
fx.ns("models.ProductBook").PORTRAIT = "portrait";
fx.ns("models.ProductBook").LANDSCAPE = "landscape";

fx.ns("models.ProductBook").SPIRAL = "spiral";
fx.ns("models.ProductBook").BIND = "bind";
fx.ns("models.ProductBook").SOFT = "standard";
fx.ns("models.ProductBook").HARD = "hard";
fx.ns("models.ProductBook").LAYFLAT = "layflat";	